import React from "react"

const Hamilton = {
  image: "https://content.landline.com/wp-content/uploads/2025/04/YHM.jpg",
  title: "Hamilton - John C. Munro International Airport (YHM)",
  prices: false,
  link: "https://www.google.com/maps/place/Terminal,+9300+Airport+Rd,+Mount+Hope,+ON+L0R+1W0,+Canada/@43.1625755,-79.9276981,721m/data=!3m1!1e3!4m14!1m7!3m6!1s0x882c8fc39d79015f:0x623aab41b06dbb3c!2sJohn+C.+Munro+Hamilton+International+Airport!8m2!3d43.1727957!4d-79.9317474!16zL20vMDVsbTlj!3m5!1s0x882c8fd0c0244561:0x11a18c6490aad740!8m2!3d43.1632243!4d-79.9263062!16s%2Fg%2F11bw3wwpny?entry=ttu&g_ep=EgoyMDI1MDQxNC4xIKXMDSoASAFQAw%3D%3D",
  address: "9300 Airport Rd, Mount Hope, ON L0R 1W0, Canada",
  directions: "Pick up/drop off is in front of the main terminal building. Please check in/wait inside the terminal until departure time.",
  parking: <span>Save money and get exclusive discounts when you <a href="https://www.figma.com/exit?url=https%3A%2F%2Fparking.flyhamilton.ca%2F" target="_blank" rel="noopener noreferrer">pre-book your parking</a> online with Hamilton Airport. Find more information about long and short term parking including rates <a href="https://flyhamilton.ca/parking-information/" target="_blank" rel="noopener noreferrer">here</a>.</span>
}

const Toronto = {
  image: "https://content.landline.com/wp-content/uploads/2025/04/YYZ.jpg",
  title: "Toronto - Toronto Pearson International Airport (YYZ)",
  prices: false,
  link: "https://www.google.com/maps/place/Toronto+Pearson+International+Airport/@43.6811941,[…]vMDZrOWw3?entry=ttu&g_ep=EgoyMDI1MDQyMC4wIKXMDSoASAFQAw%3D%3D",
  address: false,
  directions: "After arriving at YYZ, follow signs for arrivals, and proceed to baggage claim. Collect any checked luggage and proceed to the ground transportation level. Follow signs to Ride App Pick Up and proceed to door Q. A Landline/Air Canada agent at the counter next to door Q will escort you to the bus at the time of departure and load your bags.",
  parking: false
}

const Waterloo = {
  image: "https://content.landline.com/wp-content/uploads/2025/04/YKF.jpg",
  title: "Region of Waterloo International Airport (YKF)",
  prices: false,
  link: "https://www.google.com/maps/place/Region+of+Waterloo+International+Airport/data=!4m2!3m1!1s0x0:0xd1d41434a5ece244?sa=X&ved=1t:2428&ictx=111",
  address: "4881 Fountain Street N #1, Breslau, ON N0B 1M0, Canada",
  directions: "Pick up/drop off is in front of the main terminal building. Please check in/wait inside the terminal until departure time.",
  parking: <span>Find more information about long and short term parking including rates at the Region of Waterloo International Airport <a href="https://www.waterlooairport.ca/en/passengers/parking.aspx#Pay-Stations" target="_blank" rel="noopener noreferrer">here</a>.</span>
}


const HamiltonLocations = [Hamilton, Toronto]
const WaterlooLocations = [Waterloo, Toronto]

export {
  HamiltonLocations, WaterlooLocations
}
